import { render, staticRenderFns } from "./wet.vue?vue&type=template&id=752a4552&scoped=true&"
import script from "./wet.vue?vue&type=script&lang=js&"
export * from "./wet.vue?vue&type=script&lang=js&"
import style0 from "./wet.vue?vue&type=style&index=0&id=752a4552&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752a4552",
  null
  
)

export default component.exports